import React from 'react'
import { connect } from 'react-redux'
import { string, func, bool } from 'prop-types'
import FaSafari from 'react-icons/lib/fa/safari'
import Toggle from 'react-toggle'
import { toggleCompassRotate } from '../../../../store/Actions/SpiActions'
import { enableCompass } from '../../../../config'

const EnableCompass = ({ theme, compassRotate, toggleCompassRotate }) =>
  enableCompass ? (
    <li>
      <span>
        <FaSafari color={theme} />
        Compass
      </span>
      <Toggle
        defaultChecked={compassRotate}
        icons={false}
        onChange={() => toggleCompassRotate(!compassRotate)}
      />
    </li>
  ) : null

EnableCompass.propTypes = {
  theme: string.isRequired,
  compassRotate: bool.isRequired,
  toggleCompassRotate: func.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  theme: spi.theme,
  compassRotate: spi.compassRotate,
})

const mapDispatchToProps = dispatch => ({
  toggleCompassRotate: value => dispatch(toggleCompassRotate(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EnableCompass)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Settings/EnableCompass.jsx